__turbopack_context__.v({
  "arrow__down": "Accordion-module__PfL1nq__arrow__down",
  "arrow__up": "Accordion-module__PfL1nq__arrow__up",
  "blok-big-title": "Accordion-module__PfL1nq__blok-big-title",
  "blok-subtitle": "Accordion-module__PfL1nq__blok-subtitle",
  "blok-title": "Accordion-module__PfL1nq__blok-title",
  "content": "Accordion-module__PfL1nq__content",
  "item": "Accordion-module__PfL1nq__item",
  "root": "Accordion-module__PfL1nq__root",
  "trigger": "Accordion-module__PfL1nq__trigger",
});
